module.exports = __webpack_public_path__ + "img/all-2.0620778b.png";